import styled from 'styled-components';
import { Button, Link } from '../buttons';

export const SectionContainer = styled.div`
    background-color: white;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
`;

export const SectionContent = styled.div`
    padding: 20px 40px 40px;
    flex: 1;
    //padding-top: 82px;
    margin: 0;
    font-family: ${(props) => props.theme.app.font};
    color: ${(props) => props.theme.app.component.card.text.color};
    font-size: ${(props) => props.theme.app.component.card.text.size};
    font-weight: ${(props) => props.theme.app.component.card.text.weight};
`;

export const SubSectionContainer = styled.div`
    border: 1px solid #dbe2e6;
    border-radius: 8px;
    padding: 30px;
    margin-bottom: 30px;
`;

export const SectionHeader = styled.div`
    text-align: center;
    padding: 40px 40px 0px;
`;

export const SectionLink = styled(Link)`
    font-weight: 500;
    font-size: 14px;
`;

export const SectionTitle = styled.h5`
    font-size: ${(props) => props.theme.app.component.card.title.size};
    font-weight: ${(props) => props.theme.app.component.card.title.weight};
    margin: 0;
    font-family: ${(props) => props.theme.app.font};
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: ${(props) => props.theme.app.component.card.title.color};
`;

export const SectionDescription = styled.div`
    font-weight: ${(props) => props.theme.app.component.card.text.weight};
    color: ${(props) => props.theme.app.component.card.text.color};
    font-size: ${(props) => props.theme.app.component.card.text.size};
    margin-top: 0px;
    font-family: ${(props) => props.theme.app.font};
    text-align: center;

    ${SectionTitle} + & {
        padding-top: 20px;
    }
`;

export const SectionFooter = styled.div`
    padding: 20px 40px;
    position: relative;
    display: flex;

    ${Button} {
        min-width: 250px;
    }
`;

export const SectionFooterLeft = styled.div`
    flex: 1;
    display: flex;
    gap: 18px;
`;

export const SectionFooterRight = styled.div`
    flex: 1;
    display: flex;
    gap: 18px;
    justify-content: end;
`;
